<template>
    <div role="tabpanel" class="tab">
        <ul class="tab-nav" data-tab-color="teal" role="tablist">
            <li v-for="(tab,index) in tabs" class="tab-pane" :class="{active:tab.active}">
                <a href="" @click.prevent="changeTab(index)"><i :class="tab.icon" class="m-r-5" v-if="tab.icon&&tab.icon.length>0"></i>{{tab.title}}</a>
            </li>
        </ul>
        <div class="tab-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default{
        name: 'c-tabcontain',
        data() {
            return {
                tabs: [],
                oldIndex: -1
            };
        },
        props: {
            startIndex: {
                type: Number,
                default: 0
            }
        },
        mounted() {
            var vm = this;
            vm.tabs = vm.$children.filter((c) => c.$options.name === 'c-tabpage' && c.show);
            if (vm.tabs.length > 0) {
                if (vm.startIndex < 0 || vm.startIndex > (vm.tabs.length - 1)) {
                    vm.changeTab(0);
                } else {
                    vm.changeTab(vm.startIndex);
                }
            }
            for (var i = 0; i < vm.tabs.length; i++) {
                var ct = vm.tabs[i];
                //显示改变时候，刷新列表
                ct.$on('showChange', function (isShow) {
                    vm.tabs = vm.$children.filter((c) => c.$options.name === 'c-tabpage' && c.show);
                });
            }
        },
        methods: {
            changeTab(index) {
                var vm = this;
                if (vm.oldIndex === index) return; //点击当前tab
                var tab = vm.tabs[index];
                if (tab) {
                    tab.active = true;
                }
                if (vm.oldIndex > -1) {
                    vm.tabs[vm.oldIndex].active = false;
                }
                vm.oldIndex = index;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// tabcontain.vue?78270fa8